import { z } from 'zod';

/** Zod schema for creating a composition (name only; station comes from route context). */
export const composeCreateFormSchema = z.object({
  name: z.string().trim().min(1).max(500),
});

export type ComposeCreateFormValues = z.infer<typeof composeCreateFormSchema>;
